import { Grid } from '@mui/material';
import {
  MedicamentosTramitesIniciadoAutorizado,
  MedicamentosTramitesPorDelegacion,
  MedicamentosTramitesProvider,
} from '../components';

export const MedicamentosMain = () => {
  return (
    <Grid container spacing={2}>
      <Grid item container spacing={2} xs={12} md={6}>
        <MedicamentosTramitesProvider>
          <MedicamentosTramitesIniciadoAutorizado />
        </MedicamentosTramitesProvider>
      </Grid>

      <Grid item container spacing={2} xs={12} md={6}>
        <MedicamentosTramitesPorDelegacion />
      </Grid>
    </Grid>
  );
};
